import { useState } from "react";
import { NavLink } from "react-router-dom";
import type { Household } from "../../shared/types";
import { WalletIcon, SignOutIcon } from "./icons";
import { NAV } from "../lib/nav";

// Mobile-only top bar. The bottom tab bar keeps the frequently-used screens;
// less-frequent ones (Settings, Plan Ahead) plus Sign out live behind the
// profile avatar here, so the bottom bar doesn't get crowded as the app grows.
export default function MobileHeader({
  household,
  me,
  onLogout,
}: {
  household?: Household;
  me?: string;
  onLogout?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const member = household?.members.find((m) => m.name === me);
  const initial = member?.initial ?? me?.[0]?.toUpperCase() ?? "?";
  const colour = member?.colour ?? "#98A2B3";

  return (
    <header className="mobile-header">
      <div className="mobile-header__brand">
        <span className="mobile-header__logo" aria-hidden="true">
          <WalletIcon width={18} height={18} style={{ color: "#fff" }} strokeWidth={1.8} />
        </span>
        <span className="mobile-header__name">{household?.name ?? "Expense Tracker"}</span>
      </div>

      <button
        className="mobile-header__avatar"
        style={{ background: colour }}
        onClick={() => setOpen((o) => !o)}
        aria-label="Account menu"
        aria-expanded={open}
      >
        {initial}
      </button>

      {open && (
        <>
          <div className="mobile-header__scrim" onClick={() => setOpen(false)} />
          <div className="mobile-header__menu" role="menu">
            <div className="mobile-header__who">
              <span className="avatar" style={{ background: colour }}>{initial}</span>
              <span className="mobile-header__whotext">
                <strong>{me ?? "You"}</strong>
                <span>Signed in</span>
              </span>
            </div>
            {NAV.filter((n) => n.secondary).map(({ to, label, Icon }) => (
              <NavLink key={to} to={to} className="mobile-header__item" onClick={() => setOpen(false)}>
                <Icon className="mobile-header__icon" /> {label}
              </NavLink>
            ))}
            {onLogout && (
              <button className="mobile-header__item mobile-header__item--signout" onClick={onLogout} role="menuitem">
                <SignOutIcon className="mobile-header__icon" /> Sign out
              </button>
            )}
          </div>
        </>
      )}
    </header>
  );
}
